import { Injectable } from '@angular/core'
import { ApiClient, ApiClientFactory } from '@ftr/api-shared'
import { AppName, AppPlatform, AppVersionResponse } from '@ftr/contracts/api/standalone-apps'
import { ApiResult } from '@ftr/foundation'

@Injectable({
  providedIn: 'root',
})
export class StandaloneAppsCoreApiService {
  private readonly apiClient: ApiClient

  constructor(apiClientFactory: ApiClientFactory) {
    this.apiClient = apiClientFactory.build('apps')
  }

  getLatestVersion(appName: AppName, platform: AppPlatform): ApiResult<AppVersionResponse> {
    return this.apiClient.get<AppVersionResponse>({
      path: `/version/${appName}?platform=${platform}`,
      skipAuthentication: true,
    })
  }
}
